import { render, staticRenderFns } from "./monitor-wrapper.vue?vue&type=template&id=4cde4e7b&scoped=true"
import script from "./monitor-wrapper.vue?vue&type=script&lang=js"
export * from "./monitor-wrapper.vue?vue&type=script&lang=js"
import style0 from "./monitor-wrapper.vue?vue&type=style&index=0&id=4cde4e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde4e7b",
  null
  
)

export default component.exports